import * as uuid from "uuid";
import { Uuid } from "@/domains/global/identifiers";
import { ByteBuffer } from "@/modules/uuid/types";

export const _parseUuidFromByteBuffer = (uuidByteBuffer: ByteBuffer): Uuid => {
  const uuidBuffer = uuid.stringify(uuidByteBuffer);

  return uuidBuffer;
};
